import { render, staticRenderFns } from "./ProjectQuestionTestCase.vue?vue&type=template&id=e13d6d20&scoped=true&"
import script from "./ProjectQuestionTestCase.vue?vue&type=script&lang=js&"
export * from "./ProjectQuestionTestCase.vue?vue&type=script&lang=js&"
import style0 from "./ProjectQuestionTestCase.vue?vue&type=style&index=0&id=e13d6d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13d6d20",
  null
  
)

export default component.exports